import { ErrorMessageConfig, HttpErrorMessageConfig, resolveErrorMessage } from '@paysera/error-message-resolver';
import { translatorFactory } from '@assetsJsModule/i18next-react';

import sendContactForm from '../services/sendContactForm';

const useSendContactForm = async (
    request,
    loaderHandler,
    errorHandler,
    onSuccess,
    onError,
) => {
    const t = translatorFactory('PayseraContactFormBundle');

    try {
        loaderHandler.start();

        const {
            name,
            email,
            subject,
            message,
            recipient,
            attachments,
        } = request;

        await sendContactForm(
            name,
            email,
            subject,
            message,
            recipient,
            attachments,
        );

        onSuccess();
    } catch (error) {
        if (error.response && error.response.status === 429) {
            return;
        }
        const errorMessage = await resolveErrorMessage(
            error,
            (new ErrorMessageConfig(
                new HttpErrorMessageConfig(t('contact_form.failed_to_send')),
                t('contact_form.failed_to_send'),
            )),
        );

        const errors = error.response?.data?.errors || [];

        if (errors.length > 0) {
            onError(errors);
        }

        errorHandler.dispatchError(errorMessage, error);
    } finally {
        loaderHandler.stop();
    }
};

export default useSendContactForm;
